<template>
	<div class="con">
		<div class="head">
			<div class="headimg">
				<img class="user-img" :src="userInfo.headimgurl" />
			</div>
		</div>
		<div class="list">
			<div class="con-disp">
				<label>员工工号：</label>
				<input type="text" v-model.trim="workNumber" placeholder="员工工号" />
			</div>
		</div>
		<div class="btn" :class="[timer != null ? 'sub-btn-ccc' : '']" @click="emLogin">登录</div>
	</div>
</template>

<script>
	export default {
		name: 'emLogin',
		data() {
			return {
				workNumber: '',
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				type: '',//1-医生消息 2-报表
				timer: null,
			}
		},
		methods: {
			emLogin() {
				
				let data = {
					username: this.workNumber,
					wechatId: this.userInfo.openid,
					headimgurl: this.userInfo.headimgurl
				}
				if (data.username == '') {
					this.$toast("员工工号不能为空")
					return false;
				}
				let that = this;
				this.$store.commit('Load', true)
				clearTimeout(that.timer)
				that.timer = setTimeout(() => {
					that.$Axios.Post('/ygdm/ygLogin?username=' + this.workNumber + '&wechatId=' + this.userInfo.openid + '&headimgurl=' +
						that.userInfo.headimgurl, null).then(res => {
						console.log(res)
						that.$store.commit('Load', false)
						if (res.data.code == 0) {
							that.$toast("登录成功")
							localStorage.setItem('emUserInfo', JSON.stringify(res.data)); //缓存登录的员工
							setTimeout(function() {
								that.$router.push({
									path: '/doctor'
								})
								// if(this.type == 1){
									
								// }else{
								// 	that.$router.push({
								// 		path: '/statistical'
								// 	})
								// }
								
							}, 300)

						} else {
							that.$toast(res.data.msg)
						}
					}).catch(err => {
						that.$store.commit('Load', false)
						that.$toast('登录失败')
						console.log(err)
					})
					that.timer = null;
				}, 300)
			},
		},
		mounted() {
			this.type = this.$route.query.type;
			if (localStorage.getItem('emUserInfo') != undefined && localStorage.getItem('emUserInfo') != '') {
				console.log(localStorage.getItem('emUserInfo'))
				this.$router.replace({
					path: '/doctor'
				})
			}
			
		}
	}
</script>

<style scoped>
	.con {
		width: 100%;
		height: 100%;
	}

	.head {
		position: relative;
		width: 100%;
		height: 15%;
		background-color: #27BEC4;
	}

	.headimg {
		position: absolute;
		left: 0;
		right: 0;
		bottom: -60px;
		margin: auto;
		width: 120px;
		height: 120px;
		border-radius: 50%;
		background-color: #fff;
		text-align: center;
	}

	.list {
		margin-top: 100px;
		padding: 0 10px;
	}

	.user-img {
		margin-top: 10px;
		width: 100px;
		height: 100px;
		border-radius: 50%;
	}

	.con-disp {
		display: flex;
		align-items: center;
		margin-top: 20px;
	}

	.con-disp label {
		width: 80px;
		text-align: end;
		margin-right: 10px;
	}

	.con-disp input {
		padding: 10px 5px;
		width: 60%;
		border-radius: 5px;
		border: 1px solid #27BEC4;
		background-color: #fff;
	}

	.btn {
		margin: 100px auto 0;
		padding: 10px 5px;
		width: 80%;
		text-align: center;
		border: 0;
		font-size: 15px;
		border-radius: 5px;
		background-color: #27BEC4;
		color: #fff;
	}
	.sub-btn-ccc{
		background-color: #ccc;
	}
</style>
